<template>
  <div class="multimedia__content-list">
    <chat-multimedia-empty
      v-if="isEmpty"
      :tab="$t('multimedia.texts')"
      :campaign="selectedCampaignName"
    />
    <div v-else>
      <div class="multimedia__campaign texts" v-if="isHistory">
        <div>
          <span>
            {{ $t("multimedia.tab-from", { tab: $t("multimedia.texts") }) }}
          </span>
          <span class="multimedia__campaign-name"
            >{{ selectedCampaignName | truncate(20) }}
          </span>
        </div>
      </div>
      <div class="texts__search-container">
        <transition name="fade">
          <close-icon
            v-if="showInput"
            class="texts__close"
            @click="closeInput"
          />
        </transition>
        <transition
          name="searchAnimation"
          enter-active-class="slideInRight"
          leave-active-class="fadeOut"
          mode="out-in"
        >
          <input
            v-show="showInput"
            v-model="searchText"
            :placeholder="searchPlaceholder"
          />
        </transition>
        <search-icon class="texts__search" @click="showInput = true" />
      </div>
      <div
        v-for="(quick, index) in texts"
        :key="index"
        @click="selectElement(quick)"
        class="multimedia__content-item"
        :class="{
          'multimedia__content-item-break': hasLongWord(quick.text),
        }"
        role="button"
      >
        <div class="multimedia__content-item-text">
          {{ textReplaced(quick.text) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  CHAT_MULTIMEDIA_TOGGLE,
  SHORTCUTS_SELECT_TEXT,
} from '@/eventTypes';
import EventBus from '@/eventBus';
import DataBankMixin from '@/mixins/databank';
import SearchIcon from '@/assets/icons/search-texts.svg';
import CloseIcon from '@/assets/icons/close-circle.svg';

export default {
  components: {
    ChatMultimediaEmpty: () => import('@/components/ChatMultimediaEmpty.vue'),
    SearchIcon,
    CloseIcon,
  },
  mixins: [DataBankMixin],
  props: {
    selectedCampaign: {
      type: [String, null],
    },
    selectedCampaignName: {
      type: [String, null],
    },
  },
  data() {
    return {
      showInput: false,
      searchText: '',
    };
  },
  computed: {
    ...mapGetters([
      'dataBankText',
      'activeConversation',
      'activeConversationHistory',
    ]),
    conversation() {
      return !this.isHistory
        ? this.activeConversation.conversation
        : this.activeConversationHistory.conversation;
    },
    campaignId() {
      return this.conversation.campaign.id;
    },
    quickText() {
      return this.dataBankText({
        campaignId: this.selectedCampaign,
      });
    },
    isEmpty() {
      return this.quickText.length === 0;
    },
    searchPlaceholder() {
      return this.$t('multimedia.search-text');
    },
    filteredTexts() {
      return this.quickText.filter((text) => (this.normalizeString(text.text).toLowerCase())
        .includes(this.normalizeString(this.searchText).toLowerCase()));
    },
    texts() {
      return this.searchText.length > 0 ? this.filteredTexts : this.getOrderedTexts();
    },
  },
  methods: {
    selectElement(quickText) {
      EventBus.$emit(SHORTCUTS_SELECT_TEXT, {
        text: this.textReplaced(quickText.text),
        campaign: this.selectedCampaign,
      });
      EventBus.$emit(CHAT_MULTIMEDIA_TOGGLE, false);
    },
    hasLongWord(text) {
      const words = text.split(/\s+/);
      return words.some((word) => word.length > 100);
    },
    normalizeString(str) {
      return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    },
    closeInput() {
      this.showInput = false;
      this.searchText = '';
    },
    orderList(a, b) {
      if (a.order < b.order) {
        return -1;
      }
      if (a.order > b.order) {
        return 1;
      }
      return 0;
    },
    getOrderedTexts() {
      return this.quickText.sort(this.orderList);
    },

  },
};
</script>
